import { CmsApiGradFairGradProgramLinksBlockData } from 'modules/cms/api/types/CmsApiGradFairGradProgramLinks';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsGradFairGradProgramLinksBlock } from './CmsGradFairGradProgramLinksBlock';

export const CmsGradFairGradProgramLinksBlockMapping: CmsBlockMapping<CmsApiGradFairGradProgramLinksBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.INSET,
    Component: CmsGradFairGradProgramLinksBlock,
    AmpComponent: CmsGradFairGradProgramLinksBlock,
  };
